// @ts-nocheck
import {
  ALERT_DIALOG,
  ALERT_DIALOG_CLOSE,
  ALERT_DIALOG_LOADING,
} from "../constants/auth";

const initialState = {
  open: false,
  title: "",
  message: "",
  onOk: () => {},
  onClose: () => {},
  avoidCloseOnOK: false,
  isLoading: false,
  okLabel: "Ok",
  okTime: 0,
  closeLabel: "Close",
  maxWidth: "sm",
  styles: {},
  isDangerouslySetHtml: true,
};

const alertDialogReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALERT_DIALOG:
      return {
        ...state,
        open: action.payload?.open,
        title: action.payload?.title,
        message: action.payload?.message,
        onOk: action.payload?.onOk,
        avoidCloseOnOK: action?.payload?.avoidCloseOnOK,
        okLabel: action.payload?.okLabel || "Ok",
        onClose: action.payload?.onClose,
        closeLabel: action.payload?.closeLabel || "Close",
        optionalButtonLabel: action?.payload?.optionalButtonLabel || "Optional",
        onOptionalButtonClick: action?.payload?.onOptionalButtonClick,
        styles: action?.payload?.styles || {},
        okTime: action?.payload?.okTime || 0,
        maxWidth: action?.payload?.maxWidth || "sm",
        isDangerouslySetHtml:
          action?.payload?.isDangerouslySetHtml === true ||
          action?.payload?.isDangerouslySetHtml === false
            ? action?.payload?.isDangerouslySetHtml
            : true,
      };

    case ALERT_DIALOG_LOADING:
      return {
        ...state,
        isLoading:
          "payload" in action && "isLoading" in action?.payload
            ? action?.payload?.isLoading
            : true,
      };

    case ALERT_DIALOG_CLOSE:
      return {
        ...initialState,
        open: false,
      };

    default:
      return state;
  }
};

export default alertDialogReducer;
export { initialState };